// extracted by mini-css-extract-plugin
module.exports = {"overlay":"HolidayPopup_overlay__6Y2O5","modal":"HolidayPopup_modal__3Q5EA","modalMessage":"HolidayPopup_modalMessage__9hZB8","modalButton":"HolidayPopup_modalButton__FGmtk"};